"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setVisible = exports.get = void 0;
var crokinoleSimulationManager_sidecar_1 = require("@crokinole/main/crokinoleSimulationManager-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var obj = {
        isVisible: true,
    };
    return obj;
};
var setVisible = function (isVisible) {
    var obj = get();
    obj.isVisible = isVisible;
};
exports.setVisible = setVisible;
var update = function () {
    var obj = get();
    if (!obj.isVisible) {
        return;
    }
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = 20; //gb.width - 400
    var y = gb.height - 20;
    var w = 200;
    var h = 200;
    var sy = y;
    var sx = x;
    var addText = function (text, ox, oy) {
        if (ox === void 0) { ox = 0; }
        if (oy === void 0) { oy = 0; }
        diveFont_sidecar_1.diveFont.writeAbsolute(x + ox, y + oy, text, 0.5, diveColors_1.diveColors.pureWhite);
        y += 20;
    };
    var addSpacer = function () {
        y += 30;
    };
    var maxFrame = 999;
    // Current simulation frame
    y -= 20;
    x += 30;
    addText('' +
        crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().isRunning +
        '|' +
        crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().simulationMode);
    // Current simulation frame
    y -= 20;
    x += 130;
    addText('' + (crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().currentSimuationFrame % maxFrame));
    // Target simulation frame
    y -= 20;
    x += 50;
    addText('/' + (crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().simulateToFrame % maxFrame));
    // Sync and CRC errors
    y -= 20;
    x += 100;
    var report = '' +
        (websockets_sidecar_1.websockets.getGameSyncNumber() % maxFrame) +
        '-crc-' +
        crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.get().syncErrorReport;
    addText(report);
    // rogueMonofont.writeAbsolute(40, gb.height - 40, report)
};
exports.update = update;
